var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDioxin02(_ref, svgRef) {
  var {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 625.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_42",
    "data-name": "Ebene 42"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 294.86,
    cy: 275.34,
    r: 33.95,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 308.12,
    r: 54.75,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.01,
    cy: 370.42,
    r: 84.12,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 331.43,
    cy: 456.64,
    r: 69.18,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.71,
    cy: 474.14,
    r: 32.54,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66.41,
    cy: 496.04,
    r: 65.9,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 351.54,
    cy: 488.03,
    r: 48.69,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 227.94,
    cy: 490.33,
    r: 57.43,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 169.62,
    cy: 490.33,
    r: 35.84,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.78,
    cy: 446.64,
    r: 19.35,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 214.25,
    cy: 463.1,
    r: 19.35,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0.51 627.1 400.23 627.1 400.23 488.03 0.51 545.96 0.51 627.1",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.03,
    cy: 476.48,
    r: 34.19,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 306.4,
    cy: 490.33,
    r: 34.19,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.39,
    cy: 487.75,
    r: 29.18,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 183.84,
    cy: 379.98,
    r: 79.47,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.67,
    cy: 381.19,
    r: 27.97,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.42,
    cy: 462.21,
    r: 26.62,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52.9,
    cy: 486,
    r: 22.18,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.49,
    cy: 587.06,
    r: 103.77,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 278.67,
    cy: 380.95,
    r: 59.58,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 263.33,
    cy: 258.76,
    r: 31.79,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.31,
    cy: 455.08,
    r: 53.26,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.75,
    cy: 407.05,
    r: 91.14,
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 130.95,
    cy: 385.04,
    r: 66.36,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 158.72,
    cy: 428.55,
    r: 82.31,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 238.71,
    cy: 390.84,
    r: 91.9,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 69.88,
    cy: 427.49,
    r: 48.78,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 106.2,
    cy: 430.62,
    r: 36.12,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 290.56,
    cy: 285.74,
    r: 26.78,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 224.64,
    cy: 313.71,
    r: 57.68,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.58,
    cy: 335.85,
    r: 50.23,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 142.46,
    cy: 401.87,
    r: 30.18,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.2,
    cy: 513.97,
    r: 14.52,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 136.36,
    cy: 599.72,
    r: 14.52,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 322.54,
    cy: 442.79,
    r: 24.68,
    style: {
      fill: "#7d7d7d"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 248.87,
    cy: 236.97,
    r: 15.29,
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.33,
    cy: 360.37,
    r: 86.06,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.49,
    y: 350.67,
    width: 1.22,
    height: 14.08,
    transform: "translate(-115.33 108.63) rotate(-21.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.64,
    y: 334.14,
    width: 1.22,
    height: 14.08,
    transform: "translate(-131.75 529.53) rotate(-81.53)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.96,
    y: 360.21,
    width: 14.08,
    height: 1.22,
    transform: "translate(-188.41 331.26) rotate(-51.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.79,384.66a6.31,6.31,0,0,0,.41-1.9,4.16,4.16,0,0,0-.25-1.61,3.46,3.46,0,0,0-.86-1.25,4.12,4.12,0,0,0-1.41-.85,4.36,4.36,0,0,0-1.6-.28,3.4,3.4,0,0,0-1.47.37,4,4,0,0,0-1.25,1,6,6,0,0,0-.94,1.7,5.7,5.7,0,0,0-.39,1.89,3.79,3.79,0,0,0,.27,1.61,3.3,3.3,0,0,0,.86,1.26,4.36,4.36,0,0,0,3,1.12,3.4,3.4,0,0,0,1.47-.37,4.12,4.12,0,0,0,1.24-1A6,6,0,0,0,260.79,384.66Zm-1.07-.42a5.61,5.61,0,0,1-.68,1.29,3.29,3.29,0,0,1-.89.86,2.41,2.41,0,0,1-1.06.37,2.67,2.67,0,0,1-1.22-.18,2.78,2.78,0,0,1-1.05-.66,2.46,2.46,0,0,1-.56-1,3.15,3.15,0,0,1-.11-1.24,5.59,5.59,0,0,1,.35-1.41,5.29,5.29,0,0,1,.67-1.3,3.16,3.16,0,0,1,.88-.87,2.48,2.48,0,0,1,1.06-.36,2.81,2.81,0,0,1,1.24.19,2.73,2.73,0,0,1,1,.66,2.31,2.31,0,0,1,.56,1,3.27,3.27,0,0,1,.11,1.23A5.79,5.79,0,0,1,259.72,384.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.75,
    y: 382.38,
    width: 14.08,
    height: 1.22,
    transform: "translate(-143.47 179.95) rotate(-27.51)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.09,
    y: 354.85,
    width: 1.22,
    height: 14.08,
    transform: "translate(-167.92 417.7) rotate(-57.5)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.93,
    y: 371.03,
    width: 14.08,
    height: 1.22,
    transform: "translate(-105.34 633.29) rotate(-87.52)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.1,346.46a4.09,4.09,0,0,1-1,.79,3.28,3.28,0,0,1-1.18.35,3.14,3.14,0,0,1-1.27-.15,4.26,4.26,0,0,1-1.32-.73,4.16,4.16,0,0,1-1.12-1.27,3.29,3.29,0,0,1-.43-1.49,4.26,4.26,0,0,1,.28-1.64,6.46,6.46,0,0,1,1-1.74,6.15,6.15,0,0,1,1.47-1.39,4.17,4.17,0,0,1,1.56-.64,3.42,3.42,0,0,1,1.56.06,3.76,3.76,0,0,1,1.44.72,4.24,4.24,0,0,1,1,1.05,2.78,2.78,0,0,1,.43,1.1,3.13,3.13,0,0,1,0,1.14,5.77,5.77,0,0,1-.42,1.18l-1-.55a4.81,4.81,0,0,0,.31-.87,2.23,2.23,0,0,0,0-.81,1.79,1.79,0,0,0-.27-.75,2.89,2.89,0,0,0-.67-.7,2.56,2.56,0,0,0-1.1-.51,2.36,2.36,0,0,0-1.15.05,3.33,3.33,0,0,0-1.14.58,5.74,5.74,0,0,0-1.08,1.07,5.91,5.91,0,0,0-.77,1.3,3.58,3.58,0,0,0-.29,1.26,2.41,2.41,0,0,0,.23,1.13,2.54,2.54,0,0,0,.78.94,3.22,3.22,0,0,0,.92.52,2.05,2.05,0,0,0,.84.09,2.29,2.29,0,0,0,.77-.27,4,4,0,0,0,.72-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211,342.7l.91.71-5.48,7-.91-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.33,326a3.83,3.83,0,0,1-1,.78,3.06,3.06,0,0,1-2.45.21,4.48,4.48,0,0,1-1.32-.73A4.28,4.28,0,0,1,216.4,325a3.46,3.46,0,0,1-.43-1.49,4.31,4.31,0,0,1,.28-1.65,6.27,6.27,0,0,1,1-1.73,6,6,0,0,1,1.47-1.39,4.26,4.26,0,0,1,1.56-.65,3.78,3.78,0,0,1,1.57.06,4,4,0,0,1,1.43.73,4.39,4.39,0,0,1,1,1,2.9,2.9,0,0,1,.43,1.1,3,3,0,0,1,0,1.15,5.69,5.69,0,0,1-.42,1.17l-1-.54a4.81,4.81,0,0,0,.31-.87,2.29,2.29,0,0,0,0-.82,1.8,1.8,0,0,0-.27-.74,2.72,2.72,0,0,0-.67-.7,2.53,2.53,0,0,0-1.1-.52,2.64,2.64,0,0,0-1.15.05,3.46,3.46,0,0,0-1.14.59,5.16,5.16,0,0,0-1.07,1.07,5.4,5.4,0,0,0-.78,1.3,3.48,3.48,0,0,0-.29,1.25,2.39,2.39,0,0,0,.23,1.13,2.77,2.77,0,0,0,.78.95,3,3,0,0,0,.92.51,1.76,1.76,0,0,0,.84.09,2.07,2.07,0,0,0,.77-.26,4,4,0,0,0,.72-.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.23,322.28l.91.71-5.48,7-.91-.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,386.57l-8.25-5.25.37-8.46.36-8.46,8.68-4.52-.57-1.08-8.67,4.52L291,353.84,275.23,362l-17.86-6.67-6.5-16.48-17.45-2.6-3.59-9.1-1.14.45,3.59,9.09L221.74,350l-9.67-1.44-.18,1.21,9.67,1.44L228,367.6l17.56,2.62,7.44,9,.06-.09a6.55,6.55,0,0,1,.79-.79l-7.18-8.71,10.39-13.07,17.54,6.55-.72,16.68-11.16,1.88a5.31,5.31,0,0,1,.06,1.14v.09L274.38,381l15,9.53L305,382.35l8.25,5.25ZM245.66,369l-16.75-2.49-6.21-15.76,10.54-13.25L250,340l6.21,15.76Zm43.76,20.1L275.14,380l.48-11.26.25-5.66,15-7.83,14.28,9.1-.36,8.46-.37,8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.67,389.16a4.13,4.13,0,0,1-.4,1.23,3.15,3.15,0,0,1-1.89,1.58,4.74,4.74,0,0,1-1.51.16,4.44,4.44,0,0,1-1.64-.4,3.37,3.37,0,0,1-1.2-1,4.11,4.11,0,0,1-.72-1.5,6.28,6.28,0,0,1-.18-2,6.16,6.16,0,0,1,.4-2,4.28,4.28,0,0,1,.91-1.43,3.7,3.7,0,0,1,1.32-.85,4,4,0,0,1,1.6-.23,4.34,4.34,0,0,1,1.41.29,2.81,2.81,0,0,1,1.61,1.61,4.92,4.92,0,0,1,.33,1.2l-1.13.13a4.43,4.43,0,0,0-.25-.89,2.16,2.16,0,0,0-.42-.69,1.83,1.83,0,0,0-.66-.46,2.75,2.75,0,0,0-.95-.19,2.56,2.56,0,0,0-1.19.21,2.4,2.4,0,0,0-.91.7,3.49,3.49,0,0,0-.61,1.13,5.73,5.73,0,0,0-.26,1.5,5.27,5.27,0,0,0,.11,1.51,3.54,3.54,0,0,0,.48,1.19,2.35,2.35,0,0,0,.84.79,2.47,2.47,0,0,0,1.18.33A3.1,3.1,0,0,0,322,391a1.85,1.85,0,0,0,.73-.41,2,2,0,0,0,.48-.66,4.34,4.34,0,0,0,.29-.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53,383.27l1.15.06-.46,8.9-1.16-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.9,359.66a3.86,3.86,0,0,1-.4,1.23,3.15,3.15,0,0,1-.76,1,3.24,3.24,0,0,1-1.13.61,4.7,4.7,0,0,1-1.5.16,4.45,4.45,0,0,1-1.65-.4,3.37,3.37,0,0,1-1.2-1,4.27,4.27,0,0,1-.72-1.5,6.59,6.59,0,0,1-.18-2,6.15,6.15,0,0,1,.41-2,4.13,4.13,0,0,1,.91-1.43,3.75,3.75,0,0,1,1.31-.85,4,4,0,0,1,1.6-.23,4.34,4.34,0,0,1,1.41.29,2.89,2.89,0,0,1,1,.65,3,3,0,0,1,.63,1,5.41,5.41,0,0,1,.33,1.2l-1.13.13a4.43,4.43,0,0,0-.25-.89,2.18,2.18,0,0,0-.43-.69,1.79,1.79,0,0,0-.65-.46,2.86,2.86,0,0,0-.95-.19,2.62,2.62,0,0,0-1.2.21,2.48,2.48,0,0,0-.91.7,3.48,3.48,0,0,0-.6,1.13,6.06,6.06,0,0,0-.16,3,3.54,3.54,0,0,0,.48,1.19,2.35,2.35,0,0,0,.84.79,2.5,2.5,0,0,0,1.18.33,3.07,3.07,0,0,0,1.05-.1,1.9,1.9,0,0,0,.74-.41,2.16,2.16,0,0,0,.48-.66,4.34,4.34,0,0,0,.28-.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.76,353.77l1.16.06-.46,8.9-1.16-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.4,332.78V323h6.5v1.89h-4.37v2h3.73v1.89h-3.73v4Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.51,331.54h-.07a2.69,2.69,0,0,1-.26.54,1.79,1.79,0,0,1-.42.45,1.94,1.94,0,0,1-.59.31,2.76,2.76,0,0,1-.8.11,2,2,0,0,1-1.72-.75,3.45,3.45,0,0,1-.58-2.16v-4.63h2.08v4.45a1.91,1.91,0,0,0,.24,1,.9.9,0,0,0,.81.36,1.59,1.59,0,0,0,.48-.07,1.17,1.17,0,0,0,.42-.2,1.18,1.18,0,0,0,.3-.33,1,1,0,0,0,.11-.46v-4.79h2.08v7.37h-2.08Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.53,332.78v-7.37h2.08V327h.07a2,2,0,0,1,.56-1.11,1.8,1.8,0,0,1,.56-.36,2,2,0,0,1,.76-.13h.36v1.93h-.52a2.9,2.9,0,0,0-1.35.24.91.91,0,0,0-.44.89v4.31Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.45,332.78a1.33,1.33,0,0,1-.93-.35,1.62,1.62,0,0,1-.47-.94H286a1.72,1.72,0,0,1-.75,1.09,2.63,2.63,0,0,1-1.42.37,2.33,2.33,0,0,1-1.7-.59,2.1,2.1,0,0,1-.59-1.55,2,2,0,0,1,.85-1.73,4.11,4.11,0,0,1,2.31-.57h1.17v-.46a1.06,1.06,0,0,0-1.22-1.17,1.66,1.66,0,0,0-1,.27,2.84,2.84,0,0,0-.6.6l-1.24-1.1a3.3,3.3,0,0,1,1.13-1,3.87,3.87,0,0,1,1.85-.37,3.48,3.48,0,0,1,2.36.69,2.48,2.48,0,0,1,.79,2v3.24h.69v1.61Zm-2.87-1.28a1.7,1.7,0,0,0,.89-.22.78.78,0,0,0,.37-.73v-.86h-1c-.82,0-1.22.27-1.22.82v.21a.67.67,0,0,0,.25.59A1.16,1.16,0,0,0,284.58,331.5Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,332.78v-7.37h2.08v1.25h.08a2.21,2.21,0,0,1,.69-1,2.36,2.36,0,0,1,3.08.34,3.45,3.45,0,0,1,.59,2.16v4.62h-2.08v-4.45a2,2,0,0,0-.23-1.06.89.89,0,0,0-.8-.35,1.61,1.61,0,0,0-.49.07,1.3,1.3,0,0,0-.43.2,1,1,0,0,0-.3.34.93.93,0,0,0-.11.47v4.78Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.45,333a3.77,3.77,0,0,1-1.51-.28,2.92,2.92,0,0,1-1.11-.77,3.07,3.07,0,0,1-.69-1.21,5,5,0,0,1-.23-1.6,5.2,5.2,0,0,1,.22-1.58,3.28,3.28,0,0,1,.67-1.22,2.87,2.87,0,0,1,1.09-.78,3.78,3.78,0,0,1,1.47-.27,3.61,3.61,0,0,1,1.57.31,3,3,0,0,1,1.07.82,3.52,3.52,0,0,1,.6,1.21,5.12,5.12,0,0,1,.19,1.42v.62h-4.74v.11a1.64,1.64,0,0,0,.4,1.15,1.61,1.61,0,0,0,1.23.43,2,2,0,0,0,1.06-.26,4.39,4.39,0,0,0,.76-.62l1,1.29a3.31,3.31,0,0,1-1.29.91A4.85,4.85,0,0,1,301.45,333Zm-.05-6.18a1.26,1.26,0,0,0-1,.41,1.65,1.65,0,0,0-.36,1.11v.11h2.59v-.13a1.83,1.83,0,0,0-.3-1.09A1.1,1.1,0,0,0,301.4,326.77Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.45,
    cy: 468.72,
    r: 86.06,
    style: {
      fill: "#e78d38"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.51,
    y: 478.67,
    width: 1.22,
    height: 14.08,
    transform: "translate(-169.3 70.57) rotate(-21.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.96,
    y: 488.3,
    width: 14.08,
    height: 1.22,
    transform: "translate(-335.01 279.81) rotate(-51.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.72,
    y: 462.19,
    width: 1.22,
    height: 14.08,
    transform: "translate(-365.11 513.12) rotate(-81.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.45,
    y: 456.49,
    width: 1.22,
    height: 14.08,
    transform: "translate(-157.36 89.73) rotate(-21.29)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.9,
    y: 466.12,
    width: 14.08,
    height: 1.22,
    transform: "translate(-296.39 315.93) rotate(-51.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.66,
    y: 440.01,
    width: 1.22,
    height: 14.08,
    transform: "translate(-294.88 550.58) rotate(-81.28)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.26,450.67a4,4,0,0,0-1.26-1,3.35,3.35,0,0,0-1.47-.35,4,4,0,0,0-1.59.31,3.88,3.88,0,0,0-1.37.85,3.51,3.51,0,0,0-.85,1.27,4,4,0,0,0-.24,1.61,6.46,6.46,0,0,0,1.38,3.58,4,4,0,0,0,1.27,1,3.53,3.53,0,0,0,1.47.35,4.21,4.21,0,0,0,1.6-.31,4.14,4.14,0,0,0,1.39-.86,3.36,3.36,0,0,0,.84-1.27,4,4,0,0,0,.23-1.61,6.18,6.18,0,0,0-.44-1.9A5.81,5.81,0,0,0,139.26,450.67Zm.26,3.54a3.09,3.09,0,0,1-.09,1.23,2.39,2.39,0,0,1-.55,1,2.75,2.75,0,0,1-1,.67,2.82,2.82,0,0,1-1.24.21,2.34,2.34,0,0,1-1.06-.35,3.1,3.1,0,0,1-.89-.85,6.24,6.24,0,0,1-1.06-2.7,3.16,3.16,0,0,1,.09-1.24,2.33,2.33,0,0,1,.55-1,3,3,0,0,1,2.25-.88,2.42,2.42,0,0,1,1.07.35,3.31,3.31,0,0,1,.91.85,5.55,5.55,0,0,1,.69,1.28A5.88,5.88,0,0,1,139.52,454.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.78,478.39a3.84,3.84,0,0,1,.14,1.29,3,3,0,0,1-.3,1.2,3,3,0,0,1-.78,1,4.38,4.38,0,0,1-1.3.77,4.43,4.43,0,0,1-1.67.31,3.35,3.35,0,0,1-1.49-.4,4.12,4.12,0,0,1-1.27-1.08,6,6,0,0,1-1-1.74,5.81,5.81,0,0,1-.45-2,4.36,4.36,0,0,1,.25-1.68,3.66,3.66,0,0,1,.85-1.31,4,4,0,0,1,1.36-.86,4.17,4.17,0,0,1,1.4-.32,2.94,2.94,0,0,1,1.17.19,3,3,0,0,1,1,.61,5.47,5.47,0,0,1,.79,1l-1,.58a3.84,3.84,0,0,0-.59-.71,2.06,2.06,0,0,0-.67-.46,1.84,1.84,0,0,0-.78-.14,2.6,2.6,0,0,0-1,.21,2.5,2.5,0,0,0-1.55,1.7,3.55,3.55,0,0,0-.08,1.28,5.46,5.46,0,0,0,.37,1.47,5.78,5.78,0,0,0,.72,1.33,3.54,3.54,0,0,0,.93.89,2.42,2.42,0,0,0,1.09.38,2.64,2.64,0,0,0,1.21-.19,3.11,3.11,0,0,0,.91-.52,2,2,0,0,0,.51-.68,2.08,2.08,0,0,0,.16-.8,3.53,3.53,0,0,0-.09-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.05,472.26l1.09-.43,3.23,8.31-1.08.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.22,507.76a3.84,3.84,0,0,1,.14,1.29,3,3,0,0,1-1.07,2.21A4.35,4.35,0,0,1,90,512a4.25,4.25,0,0,1-1.66.32,3.35,3.35,0,0,1-1.5-.4,4.26,4.26,0,0,1-1.27-1.08,6.28,6.28,0,0,1-1-1.74,6.05,6.05,0,0,1-.45-2,4.36,4.36,0,0,1,.25-1.68,3.58,3.58,0,0,1,.85-1.31,3.9,3.9,0,0,1,1.36-.86A4.17,4.17,0,0,1,88,503a2.92,2.92,0,0,1,1.16.19,3,3,0,0,1,1,.61,5.59,5.59,0,0,1,.8,1l-1,.58a4.87,4.87,0,0,0-.6-.72,2.19,2.19,0,0,0-.67-.45,1.84,1.84,0,0,0-.78-.14,2.6,2.6,0,0,0-1,.21,2.57,2.57,0,0,0-1,.68,2.53,2.53,0,0,0-.55,1,3.51,3.51,0,0,0-.08,1.27A6.18,6.18,0,0,0,86.4,510a3.54,3.54,0,0,0,.93.89,2.42,2.42,0,0,0,1.09.38,2.62,2.62,0,0,0,1.21-.19,3,3,0,0,0,.92-.53,1.87,1.87,0,0,0,.5-.67,2.08,2.08,0,0,0,.16-.8,3.53,3.53,0,0,0-.09-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5,501.63l1.08-.43,3.23,8.31-1.08.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.17,433.05a3.84,3.84,0,0,1,.14,1.29,3.08,3.08,0,0,1-.3,1.2,3,3,0,0,1-.78,1,4.17,4.17,0,0,1-1.3.76,4.26,4.26,0,0,1-1.67.32,3.35,3.35,0,0,1-1.49-.4,4.14,4.14,0,0,1-1.27-1.08,6,6,0,0,1-1-1.74,5.81,5.81,0,0,1-.45-2,4.18,4.18,0,0,1,.25-1.68,3.45,3.45,0,0,1,.85-1.31,3.9,3.9,0,0,1,1.36-.86,4.17,4.17,0,0,1,1.4-.32,2.94,2.94,0,0,1,1.17.19,3,3,0,0,1,1,.61,4.84,4.84,0,0,1,.79,1l-1,.58a3.92,3.92,0,0,0-.59-.72,2.19,2.19,0,0,0-.67-.45,1.84,1.84,0,0,0-.78-.14,2.6,2.6,0,0,0-1,.21,2.5,2.5,0,0,0-1,.68,2.56,2.56,0,0,0-.55,1,3.58,3.58,0,0,0-.08,1.28,5.29,5.29,0,0,0,.37,1.47,5.66,5.66,0,0,0,.72,1.34,3.54,3.54,0,0,0,.93.89,2.54,2.54,0,0,0,1.09.38,2.64,2.64,0,0,0,1.21-.19,2.91,2.91,0,0,0,.91-.53,1.9,1.9,0,0,0,.51-.67,2.08,2.08,0,0,0,.16-.8,3.53,3.53,0,0,0-.09-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.44,426.91l1.09-.42,3.23,8.31-1.08.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61,462.42a3.84,3.84,0,0,1,.14,1.29,3.11,3.11,0,0,1-1.07,2.21,4.35,4.35,0,0,1-1.31.76,4.25,4.25,0,0,1-1.66.32,3.35,3.35,0,0,1-1.5-.4,4.26,4.26,0,0,1-1.27-1.08,6.28,6.28,0,0,1-1-1.74,6.05,6.05,0,0,1-.45-2,4.33,4.33,0,0,1,.25-1.68,3.58,3.58,0,0,1,.85-1.31A3.9,3.9,0,0,1,203,458a4.17,4.17,0,0,1,1.41-.32,2.75,2.75,0,0,1,1.16.19,3,3,0,0,1,1,.61,5.51,5.51,0,0,1,.8,1l-1,.59a4.4,4.4,0,0,0-.6-.72,2.19,2.19,0,0,0-.67-.45,2,2,0,0,0-.78-.15,2.86,2.86,0,0,0-.95.22,2.51,2.51,0,0,0-1.55,1.69,3.58,3.58,0,0,0-.08,1.28,6.18,6.18,0,0,0,1.09,2.81,3.71,3.71,0,0,0,.93.89,2.54,2.54,0,0,0,1.09.38,2.62,2.62,0,0,0,1.21-.19,3.09,3.09,0,0,0,.92-.53,1.87,1.87,0,0,0,.5-.67,2.08,2.08,0,0,0,.16-.8,3.53,3.53,0,0,0-.09-.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.89,456.28l1.08-.42,3.23,8.31-1.08.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.27,467.67l7.19-9-1-.77-7.16,8.94-17.52-2.69L96.79,478l-9.67-1.48-.18,1.2,9.66,1.49L102.75,495l-6.12,7.63,1,.76,6.12-7.63,17.43,2.67,11.11-13.86,11.28,1.73.19-1.2-11.36-1.75Zm5,16.18-10.59,13.22-16.74-2.57-6.15-15.78,10.6-13.21,16.73,2.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,445.45l6.12-7.63-1-.77-6.12,7.64L164.76,442l-11.07,13.81-11.33-1.74-.19,1.21L153.56,457l6.09,15.63-7.21,9,1,.76,7.15-8.92,17.53,2.69,11-13.76,9.67,1.48.19-1.21-9.67-1.48Zm-5.58,29.44-16.74-2.57-6.15-15.78,10.59-13.21L182,445.89l6.15,15.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,485.15a6.08,6.08,0,0,0-1-1.69,4,4,0,0,0-1.26-1,3.36,3.36,0,0,0-1.47-.36,4.09,4.09,0,0,0-1.61.3,4.2,4.2,0,0,0-1.38.86,3.24,3.24,0,0,0-.85,1.25,3.82,3.82,0,0,0-.24,1.61,5.79,5.79,0,0,0,.42,1.89,5.89,5.89,0,0,0,1,1.68,4.06,4.06,0,0,0,1.28,1,3.39,3.39,0,0,0,1.47.36,4.06,4.06,0,0,0,1.59-.29,4.14,4.14,0,0,0,1.39-.86,3.21,3.21,0,0,0,.84-1.25,4.11,4.11,0,0,0,.24-1.6A5.82,5.82,0,0,0,153,485.15Zm-1.08.4a5.63,5.63,0,0,1,.36,1.41,3.16,3.16,0,0,1-.09,1.24,2.38,2.38,0,0,1-.55,1,2.56,2.56,0,0,1-1,.67,2.78,2.78,0,0,1-1.23.21,2.5,2.5,0,0,1-1.08-.35,3.25,3.25,0,0,1-.89-.85,5.63,5.63,0,0,1-.69-1.29,5.85,5.85,0,0,1-.37-1.42,3.25,3.25,0,0,1,.08-1.22,2.29,2.29,0,0,1,.56-1,3.1,3.1,0,0,1,2.26-.89,2.38,2.38,0,0,1,1.07.35,3.27,3.27,0,0,1,.9.85A5.24,5.24,0,0,1,151.92,485.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31,513.42H140a5.06,5.06,0,0,1,1.77.3,3.77,3.77,0,0,1,1.36.92,4.34,4.34,0,0,1,.87,1.54,7.54,7.54,0,0,1,0,4.28,4.38,4.38,0,0,1-.87,1.53,3.53,3.53,0,0,1-1.36.92,4.84,4.84,0,0,1-1.77.31h-3.7Zm3.7,7.9a2.05,2.05,0,0,0,1.5-.53,2.34,2.34,0,0,0,.55-1.71v-1.52a2.31,2.31,0,0,0-.55-1.71,2.06,2.06,0,0,0-1.5-.54h-1.56v6Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,515.06a1.27,1.27,0,0,1-.92-.29,1,1,0,0,1-.29-.74v-.31a1,1,0,0,1,.29-.73,1.6,1.6,0,0,1,1.84,0,1,1,0,0,1,.29.73V514a1,1,0,0,1-.29.74A1.27,1.27,0,0,1,147,515.06Zm-1,.79h2.08v7.37H146Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,523.39a3.68,3.68,0,0,1-1.45-.27,2.82,2.82,0,0,1-1.09-.77,3.61,3.61,0,0,1-.68-1.22,5,5,0,0,1-.24-1.6,5.09,5.09,0,0,1,.24-1.61,3.56,3.56,0,0,1,.68-1.21,3,3,0,0,1,1.09-.77,4.17,4.17,0,0,1,2.9,0,3,3,0,0,1,1.09.77,3.56,3.56,0,0,1,.68,1.21,5.09,5.09,0,0,1,.24,1.61,5,5,0,0,1-.24,1.6,3.61,3.61,0,0,1-.68,1.22,2.82,2.82,0,0,1-1.09.77A3.68,3.68,0,0,1,153,523.39Zm0-1.64a1.24,1.24,0,0,0,1-.38,1.63,1.63,0,0,0,.33-1.09v-1.5a1.59,1.59,0,0,0-.33-1.08,1.4,1.4,0,0,0-1.92,0,1.59,1.59,0,0,0-.33,1.08v1.5a1.63,1.63,0,0,0,.33,1.09A1.24,1.24,0,0,0,153,521.75Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,523.22l2.43-3.75-2.4-3.62h2.36l1.37,2.31h.06l1.33-2.31h2.2l-2.45,3.69,2.46,3.68H162l-1.42-2.4h0l-1.37,2.4Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.61,515.06a1.27,1.27,0,0,1-.92-.29,1,1,0,0,1-.29-.74v-.31a1,1,0,0,1,.29-.73,1.6,1.6,0,0,1,1.84,0,1,1,0,0,1,.29.73V514a1,1,0,0,1-.29.74A1.27,1.27,0,0,1,166.61,515.06Zm-1,.79h2.08v7.37h-2.08Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.59,523.22v-7.37h2.08v1.25h.08a2.21,2.21,0,0,1,.69-1,2.36,2.36,0,0,1,3.08.34,3.45,3.45,0,0,1,.59,2.16v4.62H174v-4.45a2,2,0,0,0-.23-1.06.88.88,0,0,0-.8-.35,1.66,1.66,0,0,0-.49.07,1.3,1.3,0,0,0-.43.2,1.22,1.22,0,0,0-.3.34,1.06,1.06,0,0,0-.11.48v4.77Z",
    style: {
      fill: "#555"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,523.39a3.93,3.93,0,0,1-1.5-.27,3,3,0,0,1-1.12-.78,3.07,3.07,0,0,1-.69-1.21,5.33,5.33,0,0,1-.23-1.6,5.2,5.2,0,0,1,.22-1.58,3.43,3.43,0,0,1,.67-1.22,3,3,0,0,1,1.09-.78,3.78,3.78,0,0,1,1.47-.27,3.57,3.57,0,0,1,1.57.31,2.86,2.86,0,0,1,1.07.83,3.23,3.23,0,0,1,.6,1.2,5.12,5.12,0,0,1,.19,1.42v.62h-4.73v.11a1.44,1.44,0,0,0,1.63,1.58,1.94,1.94,0,0,0,1.05-.26,4,4,0,0,0,.76-.62l1,1.29a3.31,3.31,0,0,1-1.29.91A4.85,4.85,0,0,1,181,523.39Zm0-6.18a1.23,1.23,0,0,0-1,.41,1.65,1.65,0,0,0-.36,1.11v.11h2.58v-.13a1.83,1.83,0,0,0-.3-1.09A1.08,1.08,0,0,0,181,517.21Z",
    style: {
      fill: "#555"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDioxin02);
export default __webpack_public_path__ + "static/media/dioxin_02.e94f3ed4ab816aed2c0e9fedbab79f2a.svg";
export { ForwardRef as ReactComponent };